export const BUSINESS_ERROR_CODES = {
    DATE_ALREADY_CHANGED: '600011'
};
